import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=0ec541d0&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Leave.vue?vue&type=style&index=1&id=0ec541d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec541d0",
  null
  
)

export default component.exports